export default "__VITE_ASSET__CdpdhE55__"